import React, { useEffect, useState } from 'react'
import PlusIcon from '../../../../components/Icons/PlusIcon';
import { useFieldArray, useForm } from 'react-hook-form';
import DeleteIcon from '../../../../components/Icons/DeleteIcon';
import { toast } from 'react-toastify';
import { formatAmount, parseAmount, printData } from '../../../../utility/CommonFunctions';
import { useNavigate } from 'react-router-dom';
import { callApi } from '../../../../ApiHelper/ApiHelper';
import { apiUrl } from '../../../../ApiHelper/ApiUrl';
import EditIcon from '../../../../components/Icons/EditIcon';
import EditItemModel from './EditItemModel';
import { Spinner } from 'reactstrap';
import ConfirmModal from '../../../../components/comman/ConfirmModal';
import BgBlurLoader from '../../../../components/Loaders/BgBlurLoader';

export default function StaffBudget({ pageStates, type, ThirdFormSubmit, EditData = null, GetSiteBudgets, isLoading, budgetLoading,
    setBudgetLoading }) {
    const {
        register,
        control,
        watch,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        reset
    } = useForm({
        defaultValues: {
            expenseHead: [{ departmentId: "", expectedAmount: "", cashflowAmount: "", itemsData: [], items: [], siteBudgetId: "" }],
        },
    });
    const navigate = useNavigate();
    const [model, setModel] = useState({
        editModel: false,
        deleteItemModel: false,
        deleteSectionModel: false
    });
    const [state, setState] = useState({
        itemDetails: null,
        editItem: {
            expenseIndex: "",
            itemIndex: "",
            siteBudgetItemId: ""
        },
        isItemDeleteLoading: false
    })

    const toggleModel = (type, editItem) => {
        setModel((prev) => ({
            ...prev,
            [type]: !prev?.[type]
        }));
        if (type === "deleteItemModel" || type === "deleteSectionModel") {
            setState((prev) => ({
                ...prev,
                editItem: editItem ? editItem : {
                    expenseIndex: "",
                    itemIndex: "",
                    siteBudgetItemId: ""
                }
            }))
        }
    }

    const { fields: fieldsSupply, append: appendSupply, remove: removeSupply } =
        useFieldArray({
            control,
            name: "expenseHead",
        });

    const watchItems = watch("expenseHead") || [];

    useEffect(() => {
        // printData("Staff", EditData)
        if (!EditData || pageStates?.departmentList?.length === 0) {
            reset({
                expenseHead: [{ departmentId: "", expectedAmount: "", cashflowAmount: "", itemsData: [], items: [], siteBudgetId: "", description: "" }]
            });
            setBudgetLoading(false);
            return;
        };
        const fetchData = async () => {
            setBudgetLoading(true);
            const expenseHead = await Promise.all(
                EditData.map(async (expense, index) => {
                    const res = await fetchItemsForExpenseHead(index, expense?.departmentId);
                    return {
                        cashflowAmount: expense?.cashflowAmount,
                        expectedAmount: formatAmount(expense?.expectedAmount),
                        departmentId: expense?.departmentId,
                        description: expense?.description,
                        itemsData: res?.data?.designation,
                        siteBudgetId: expense?.id,
                        items: expense?.sitebudgetitems?.map(({ designationId, quantity, month, unitRate, total, designation, id, freezedQuantity
                        }) => ({
                            item: designationId,
                            month: month,
                            quantity,
                            rate: unitRate,
                            name: designation?.name,
                            siteBudgetItemId: id,
                            freezedQuantity: freezedQuantity,
                            amount: formatAmount(total),
                        })),
                    };
                })
            )
            reset({ expenseHead });
        };
        fetchData();
        setBudgetLoading(false);
    }, [EditData, pageStates?.departmentList]);


    // Function to add new Expense Head
    const addExpenseHead = () => {
        appendSupply({ departmentId: "", expectedAmount: "", cashflowAmount: "", items: [], siteBudgetId: "", description: "" });
    };

    // Function to add item dynamically
    const addItem = (index, data) => {
        const siteBudgetId = getValues(`expenseHead.${index}.siteBudgetId`);
        const itemData = getValues(`expenseHead.${index}.itemsData`);
        if (EditData && siteBudgetId) {
            toggleModel("editModel");
            setState((prev) => ({
                ...prev,
                itemDetails: {
                    ...data, itemsData: itemData, selectedValue: getValues(
                        `expenseHead.${index}.items`
                    ).map((item) => item.item),
                    actionMode: "Add"
                }
            }))
        } else {

            const selectedExpenseHead = getValues(`expenseHead.${index}.departmentId`);

            if (!selectedExpenseHead) return toast.info("Please select an Department first!");

            const newItem = {
                item: "",
                quantity: "",
                month: "",
                rate: "",
                amount: formatAmount(0),
            };

            const currentItems = getValues(`expenseHead.${index}.items`) || [];
            setValue(`expenseHead.${index}.items`, [...currentItems, newItem]);
        }
    };


    const fetchItemsForExpenseHead = async (expenseIndex, expenseHeadId) => {
        if (!expenseHeadId) return;

        let options = { method: "GET" };
        let API = apiUrl?.get_designation + `?departmentId=${expenseHeadId}`;
        let response = await callApi(API, options);

        setValue(`expenseHead.${expenseIndex}.itemsData`, response?.data?.designation);

        return response
    };

    // Form submission handler
    const onSubmit = (data) => {
        const hasEmptyItems = data?.expenseHead?.some(
            (head) => !head?.siteBudgetId && (!head?.items || head?.items.length === 0)
        );

        if (hasEmptyItems) {
            toast.info("Please add at least one item in each section");
            return;
        }

        // You can make an API call here to send data to the server
        const siteBudget = data?.expenseHead?.filter(item => !item?.siteBudgetId)?.map((items) => ({
            cashflowAmount: items?.cashflowAmount,
            expectedAmount: parseAmount(items?.expectedAmount),
            departmentId: items?.departmentId,
            description: items?.description,
            siteBudgetItem: items?.items?.map((siteBudgetItem) => ({
                designationId: siteBudgetItem?.item,
                month: siteBudgetItem?.month,
                quantity: siteBudgetItem?.quantity,
                unitRate: siteBudgetItem?.rate,
                total: parseAmount(siteBudgetItem?.amount)
            }))
        }));
        // console.log("Submitted Data:", siteBudget);
        ThirdFormSubmit(siteBudget, "staffBudget");
    };

    const handleUpdateAmount = (expenseIndex, itemIndex, fieldType, value) => {
        const updatedValue = value;

        // Update the respective field (quantity or rate)
        setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.${fieldType}`, updatedValue);

        // Get the current state of expense items
        const currentItems = watch(`expenseHead.${expenseIndex}.items`) || [];
        const item = currentItems[itemIndex] || {};

        // Extract values safely (default to 0 if missing)
        const quantity = fieldType === "quantity" ? parseFloat(updatedValue) : parseFloat(item.quantity) || 0;
        const month = fieldType === "month" ? parseFloat(updatedValue) : parseFloat(item.month) || 0;
        const rate = fieldType === "rate" ? parseFloat(updatedValue) : parseFloat(item.rate) || 0;

        // Calculate base amount
        const baseAmount = quantity * rate * month;

        // Update the amount field
        setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.amount`, formatAmount(baseAmount || 0));

        // Calculate the total for the Expense Head
        const expenseHeadTotal = (currentItems || []).reduce((sum, itm) => {
            return sum + parseAmount(itm.amount || "0");
        }, 0);

        setValue(`expenseHead.${expenseIndex}.expectedAmount`, formatAmount(expenseHeadTotal || 0));

    };

    const GetGrandTotal = () => {
        let newGrandTotal = 0;
        watchItems.forEach((expense) => {
            newGrandTotal += parseAmount(expense.expectedAmount || "0");
        });
        return newGrandTotal;
    };

    const isItemFromEditData = (departmentId, itemId) => {
        // console.log(departmentId, itemId)
        if (!EditData || !departmentId || !itemId) return false;

        const matchingExpense = EditData.find(
            (head) => head.departmentId === departmentId
        );
        // console.log("matchingExpense", matchingExpense)
        if (!matchingExpense) return false;

        return matchingExpense.sitebudgetitems?.some((i) => i.designation.id === itemId);
    };

    const handleDeleteItemFromCreate = (expenseIndex, itemIndex) => {
        const items = getValues(`expenseHead.${expenseIndex}.items`) || [];
        const deletedItemAmount = parseAmount(items[itemIndex]?.amount || "0");

        const updatedItems = items.filter((_, idx) => idx !== itemIndex);
        setValue(`expenseHead.${expenseIndex}.items`, updatedItems);

        const currentTotal = parseAmount(
            getValues(`expenseHead.${expenseIndex}.expectedAmount`) || "0"
        );
        const newTotal = currentTotal - deletedItemAmount || 0;
        setValue(
            `expenseHead.${expenseIndex}.expectedAmount`,
            formatAmount(newTotal)
        );
    };

    const handleDeleteItemFromEdit = async (
        expenseIndex,
        itemIndex,
        siteBudgetItemId
    ) => {
        // toast.info("from api ");
        // console.log("expenseIndex ", expenseIndex, "itemIndex ", itemIndex, "siteBudgetItemId ", siteBudgetItemId);
        setState((prev) => ({
            ...prev,
            isItemDeleteLoading: true,
        }))
        const Url = `${apiUrl.delete_site_budget}?siteBudgetItemId=${state.editItem.siteBudgetItemId}`;
        callApi(Url, {
            method: "GET",
        }).then((response) => {
            setState((prev) => ({
                ...prev,
                isItemDeleteLoading: true,
            }))
            if (response?.status) {
                handleDeleteItemFromCreate(state.editItem?.expenseIndex, state.editItem?.itemIndex);
                toggleModel("deleteItemModel");
            } else {
                toast.error(response?.message);
            }
        });
    };


    const handleDeleteSection = async (type = null, index) => {
        // toast.info("from api ");
        // console.log("siteBudgetId: ", siteBudgetId, "index: ", index,);

        if (type) {
            setState((prev) => ({
                ...prev,
                isItemDeleteLoading: true,
            }));
            const Url = `${apiUrl.delete_site_budget}?siteBudgetId=${state?.editItem?.siteBudgetItemId}`;
            callApi(Url, {
                method: "GET",
            }).then((response) => {
                setState((prev) => ({
                    ...prev,
                    isItemDeleteLoading: false,
                }));
                if (response?.status) {
                    removeSupply(state?.editItem?.expenseIndex);
                    toggleModel("deleteSectionModel");
                } else {
                    toast.error(response?.message);
                }
            });
        } else {
            removeSupply(index);
        }
    };


    return (
        <div>
            {
                budgetLoading ? <BgBlurLoader /> :
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="card">
                            <div className="card-body">
                                <div className="col-12">
                                    <div className="col-12 d-flex justify-content-between rajdhani-semibold my-4 border-bottom pb-3">
                                        <h4 className="fs-3 ">
                                            {type}
                                        </h4>
                                        <h4 className="fs-3 rajdhani-semibold">
                                            Grand Total: {formatAmount(GetGrandTotal())}
                                        </h4>
                                    </div>
                                    {fieldsSupply.map((field, index) => {
                                        const items = watch(`expenseHead.${index}.items`) || [];
                                        const isAnyDeleteDisabled = items.some(
                                            (item) => item?.freezedQuantity != null && item?.freezedQuantity != "0"
                                        );

                                        return (
                                            <div className="border p-3 rounded mb-4" key={field.siteBudgetId}>
                                                <div className="row mb-3">
                                                    {/* Expense Head */}
                                                    <div className="col-12 col-md-6 col-lg-3">
                                                        <div className="form-group mb-3">
                                                            <label className="form-label">Department</label>
                                                            <select
                                                                className="form-select form-control"
                                                                {...register(`expenseHead.${index}.departmentId`, {
                                                                    required: "This field is required",
                                                                })}
                                                                onChange={(e) => fetchItemsForExpenseHead(index, e.target.value)}
                                                                disabled={EditData?.some(
                                                                    (item) =>
                                                                        item.departmentId ===
                                                                        watch(`expenseHead.${index}.departmentId`)
                                                                )}
                                                            >
                                                                <option value="" className="d-none">
                                                                    Select Department
                                                                </option>
                                                                {pageStates?.departmentList?.map((item) => {
                                                                    const isDisabled = fieldsSupply?.some((expense) => expense?.departmentId === item.id);
                                                                    return (
                                                                        <option key={item.id} value={item.id} disabled={isDisabled}>
                                                                            {item.name}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>

                                                            {errors?.expenseHead?.[index]?.departmentId && (
                                                                <div className="form-text text-danger">
                                                                    {errors.expenseHead[index].departmentId.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>


                                                    {/* Description */}
                                                    <div className="col-12 col-md-6 col-lg-9">
                                                        <div className="form-group mb-3">
                                                            <label className="form-label">Description</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter description"
                                                                {...register(`expenseHead.${index}.description`)}
                                                                disabled={!!EditData}
                                                            />
                                                            {errors?.expenseHead?.[index]?.description && (
                                                                <div className="form-text text-danger">
                                                                    {errors.expenseHead[index].description.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Add Items Button */}
                                                {!EditData && <div className="d-flex justify-content-between align-items-center" >
                                                    <h4 className="fs-3 rajdhani-semibold my-4">Item Details</h4>
                                                    <button
                                                        className="btn btn-outline-primary mx-2"
                                                        type="button"
                                                        onClick={() => addItem(index, field)}
                                                    >
                                                        <PlusIcon /> Add Items
                                                    </button>
                                                </div>}

                                                {/* Item Table */}
                                                <table className="table mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th>Designation</th>
                                                            <th>Quantity</th>
                                                            <th>Freezed Quantity</th>
                                                            <th>Month</th>
                                                            <th>Unit Rate</th>
                                                            <th>Amount</th>
                                                            {!EditData && <th>Action</th>}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {watch(`expenseHead.${index}.items`, []).map((item, i) => {
                                                            const departmentId = watch(
                                                                `expenseHead.${index}.departmentId`
                                                            );
                                                            const currentItemId = watch(
                                                                `expenseHead.${index}.items.${i}.item`
                                                            );
                                                            const isDisabledRow = isItemFromEditData(
                                                                departmentId,
                                                                currentItemId
                                                            );
                                                            return (
                                                                <tr key={i}>
                                                                    <td style={{ width: "25rem" }}>
                                                                        <select
                                                                            className="form-control form-select"
                                                                            {...register(`expenseHead.${index}.items.${i}.item`, {
                                                                                required: "Please select an item",
                                                                            })}
                                                                            disabled={isDisabledRow}
                                                                        >
                                                                            <option value="" className="d-none">Select Designation</option>
                                                                            {watch(`expenseHead.${index}.itemsData`)?.map((items) => {
                                                                                // Get all selected item IDs for this expenseHead

                                                                                const selectedItems = getValues(`expenseHead.${index}.items`).map((item) => item.item);

                                                                                return (
                                                                                    <option key={items.id} value={items.id} disabled={selectedItems.includes(items.id)}>
                                                                                        {items.name}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            {...register(`expenseHead.${index}.items.${i}.quantity`, {
                                                                                required: "Enter Quantity",
                                                                                min: { value: 1, message: "At least 1" },
                                                                            })}
                                                                            min={0}
                                                                            placeholder="Quantity"
                                                                            onChange={(e) => {
                                                                                let value = e.target.value
                                                                                    .replace(/[^0-9.]/g, "") // Allow only digits and dots
                                                                                    .replace(/(\..*)\./g, "$1"); // Prevent multiple dots

                                                                                // Ensure a valid floating-point format
                                                                                if (!/^\d*\.?\d*$/.test(value)) {
                                                                                    value = "";
                                                                                }
                                                                                e.target.value = value; // Update input field
                                                                                handleUpdateAmount(index, i, "quantity", value)
                                                                            }}
                                                                            disabled={isDisabledRow}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            {...register(
                                                                                `expenseHead.${index}.items.${i}.freezedQuantity`,
                                                                            )}
                                                                            value={item?.freezedQuantity || 0}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            {...register(`expenseHead.${index}.items.${i}.month`, {
                                                                                required: "Enter Month",
                                                                                min: { value: 1, message: "At least 1" },
                                                                            })}
                                                                            min={0}
                                                                            placeholder="Month"
                                                                            onChange={(e) => {
                                                                                let value = e.target.value.replace(/[^0-9]/g, ""); // Allow only digits (whole numbers)
                                                                                e.target.value = value; // Update input field
                                                                                handleUpdateAmount(index, i, "month", value)
                                                                            }}
                                                                            disabled={isDisabledRow}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            {...register(`expenseHead.${index}.items.${i}.rate`, {
                                                                                required: "Enter Rate",
                                                                                min: { value: 0.01, message: "Positive number required" },
                                                                            })}
                                                                            min={0}
                                                                            placeholder="Unit Rate"
                                                                            onChange={(e) => {
                                                                                let value = e.target.value
                                                                                    .replace(/[^0-9.]/g, "") // Allow only digits and dots
                                                                                    .replace(/(\..*)\./g, "$1"); // Prevent multiple dots

                                                                                // Ensure a valid floating-point format
                                                                                if (!/^\d*\.?\d*$/.test(value)) {
                                                                                    value = "";
                                                                                }
                                                                                e.target.value = value; // Update input field
                                                                                handleUpdateAmount(index, i, "rate", value)
                                                                            }}
                                                                            disabled={isDisabledRow}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            readOnly
                                                                            disabled
                                                                            {...register(`expenseHead.${index}.items.${i}.amount`)}
                                                                            placeholder="Amount"

                                                                        />
                                                                    </td>

                                                                    {!EditData && <td>
                                                                        {isDisabledRow && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-primary"
                                                                                onClick={() => {
                                                                                    toggleModel("editModel");
                                                                                    // console.log("items>>>", item)
                                                                                    setState((prev) => ({
                                                                                        ...prev,
                                                                                        itemDetails: {
                                                                                            ...item, itemsData: field?.itemsData,
                                                                                            id: field?.siteBudgetId, actionMode: "Edit"
                                                                                        }
                                                                                    }))
                                                                                }}
                                                                            >
                                                                                <EditIcon />
                                                                            </button>
                                                                        )}
                                                                        <button
                                                                            className="btn btn-outline-danger mx-3"
                                                                            type="button"
                                                                            onClick={() => {
                                                                                if (isDisabledRow) {
                                                                                    const editItemData = {
                                                                                        expenseIndex: index,
                                                                                        itemIndex: i,
                                                                                        siteBudgetItemId: item?.siteBudgetItemId,
                                                                                    }
                                                                                    toggleModel("deleteItemModel", editItemData)
                                                                                } else {
                                                                                    handleDeleteItemFromCreate(index, i);
                                                                                }
                                                                            }}
                                                                            disabled={item?.freezedQuantity == null || item?.freezedQuantity == "0" ? false : true}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </button>

                                                                    </td>}
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                    {watch(`expenseHead.${index}.items`, []).length > 0 && <tfoot>
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            {!EditData && <td></td>}
                                                            <td className="fw-bold">Expected amount</td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    {...register(`expenseHead.${index}.expectedAmount`)}
                                                                    readOnly
                                                                    disabled
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            {!EditData && <td></td>}
                                                            {/* <td className="fw-bold">Cashflow Amount</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                {...register(`expenseHead.${index}.cashflowAmount`)}
                                                                onChange={(e) => {
                                                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                                                }}
                                                            />
                                                        </td> */}
                                                        </tr>
                                                    </tfoot>}
                                                </table>

                                                {!EditData && (
                                                    <div className="text-end">
                                                        <button
                                                            className="btn btn-outline-danger ms-3 py-2"
                                                            type="button"
                                                            onClick={() => {
                                                                if (watch(`expenseHead.${index}.siteBudgetId`)) {
                                                                    const editItemData = {
                                                                        expenseIndex: index,
                                                                        siteBudgetItemId: watch(`expenseHead.${index}.siteBudgetId`),
                                                                        itemIndex: ""
                                                                    }
                                                                    toggleModel("deleteSectionModel", editItemData);
                                                                } else {
                                                                    handleDeleteSection(null, index)
                                                                }
                                                            }
                                                            }
                                                            disabled={isAnyDeleteDisabled}
                                                        >
                                                            <DeleteIcon /> Remove Section
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }

                                    )}
                                </div>
                                {/* Add Expense Head Button */}
                                {!EditData && <div className="col text-end" >
                                    <button
                                        className="btn btn-primary py-2 fw-bold"
                                        type="button"
                                        onClick={addExpenseHead}
                                    >
                                        <span className="bg-light">
                                            <PlusIcon />
                                        </span>{" "}
                                        Add Section
                                    </button>
                                </div>}
                                {/* Submit Button */}
                                {watch("expenseHead")?.some(item => !item?.siteBudgetId) && <div className="d-flex align-items-center justify-content-end gap-4 mt-4">
                                    <button
                                        className="btn btn-secondary px-4"
                                        type="button"
                                        onClick={() => navigate(-1)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-primary px-4"
                                        type="submit"
                                    >
                                        {isLoading ? <Spinner /> : "Save"}
                                    </button>
                                </div>}
                            </div>
                        </div>
                    </form >
            }
            <EditItemModel
                modal={model?.editModel}
                toggle={() => toggleModel("editModel")}
                type={type}
                modalData={state.itemDetails}
                getSiteItems={GetSiteBudgets} />
            <ConfirmModal
                modal={model.deleteItemModel}
                toggle={() => toggleModel('deleteItemModel')}
                submitHandler={handleDeleteItemFromEdit}
                isLoading={state.isItemDeleteLoading}
            />
            <ConfirmModal
                modal={model.deleteSectionModel}
                toggle={() => toggleModel('deleteSectionModel')}
                submitHandler={() => handleDeleteSection("deleteSectionModel")}
                isLoading={state.isItemDeleteLoading}
            />
        </div >
    );
}
